import Image from 'components/common/Image';
import { Box, Markdown, Text } from 'grommet';
import useResponsive from 'hooks/useResponsive';
import EditAssetButton from 'modules/admin/components/EditAssetButton';
import FileActionEditor from 'modules/admin/components/FileActionEditor';
import { LinkItem } from 'modules/root/components/LinkItem';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Asset } from 'types';
import { formatDate } from 'utils/stringUtils';

const NewsItems = ({
  markdown,
  image,
  id,
  shortid,
  createdAt,
  label,
}: Asset) => {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const overflow = markdown.length > 200;
  const text = !overflow ? markdown : `${markdown.substring(0, 200)}...`;
  const route = `/nyheter/${shortid}`;
  return (
    <Box
      as="article"
      justify="center"
      align={isMobile ? 'stretch' : 'center'}
      direction={isMobile ? 'column' : 'row'}
      animation="fadeIn"
      width={{ max: 'large' }}
      fill="horizontal"
    >
      <Box
        elevation="large"
        background="light-3"
        height={isMobile ? '200px' : '250px'}
        width={isMobile ? '100%' : '250px'}
        flex={false}
        onClick={() => navigate(route)}
      >
        <Image src={image} />
      </Box>
      <Box
        height={isMobile ? undefined : 'medium'}
        width={isMobile ? '100%' : 'medium'}
        justify={isMobile ? 'start' : 'center'}
        pad="medium"
        style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}
      >
        <Text
          size="xlarge"
          weight="bold"
          style={{ cursor: 'pointer' }}
          onClick={() => navigate(route)}
        >
          {label}
        </Text>
        <Markdown>{text}</Markdown>
        {overflow && (
          <LinkItem color="black" route={route}>
            Les mer her
          </LinkItem>
        )}
        {createdAt && (
          <Text size="small" textAlign="end">
            {formatDate(createdAt)}
          </Text>
        )}
        <EditAssetButton shortid={shortid} label="Endre nyhet" type="nyheter" />
      </Box>
    </Box>
  );
};

export default NewsItems;
